import { computed as n } from "vue";
import A from "./ghl-ui.es1117.js";
import I from "./ghl-ui.es1127.js";
import M from "./ghl-ui.es1128.js";
function V(s, r) {
  const l = n(() => {
    const {
      isTimeDisabled: i
    } = s, {
      value: e
    } = r;
    if (!(e === null || Array.isArray(e)))
      return i == null ? void 0 : i(e);
  }), d = n(() => {
    var i;
    return (i = l.value) === null || i === void 0 ? void 0 : i.isHourDisabled;
  }), o = n(() => {
    var i;
    return (i = l.value) === null || i === void 0 ? void 0 : i.isMinuteDisabled;
  }), v = n(() => {
    var i;
    return (i = l.value) === null || i === void 0 ? void 0 : i.isSecondDisabled;
  }), c = n(() => {
    const {
      type: i,
      isDateDisabled: e
    } = s, {
      value: a
    } = r;
    return a === null || Array.isArray(a) || !["date", "datetime"].includes(i) || !e ? !1 : e(a, {
      type: "input"
    });
  }), f = n(() => {
    const {
      type: i
    } = s, {
      value: e
    } = r;
    if (e === null || i === "datetime" || Array.isArray(e))
      return !1;
    const a = new Date(e), t = a.getHours(), u = a.getMinutes(), b = a.getMinutes();
    return (d.value ? d.value(t) : !1) || (o.value ? o.value(u, t) : !1) || (v.value ? v.value(b, u, t) : !1);
  }), D = n(() => c.value || f.value);
  return {
    // date & datetime
    isValueInvalidRef: n(() => {
      const {
        type: i
      } = s;
      return i === "date" ? c.value : i === "datetime" ? D.value : !1;
    }),
    isDateInvalidRef: c,
    // datetime only
    isTimeInvalidRef: f,
    isDateTimeInvalidRef: D,
    isHourDisabledRef: d,
    isMinuteDisabledRef: o,
    isSecondDisabledRef: v
  };
}
function j(s, r) {
  const l = n(() => {
    const {
      isTimeDisabled: e
    } = s, {
      value: a
    } = r;
    return !Array.isArray(a) || !e ? [void 0, void 0] : [e == null ? void 0 : e(a[0], "start", a), e == null ? void 0 : e(a[1], "end", a)];
  }), d = {
    isStartHourDisabledRef: n(() => {
      var e;
      return (e = l.value[0]) === null || e === void 0 ? void 0 : e.isHourDisabled;
    }),
    isEndHourDisabledRef: n(() => {
      var e;
      return (e = l.value[1]) === null || e === void 0 ? void 0 : e.isHourDisabled;
    }),
    isStartMinuteDisabledRef: n(() => {
      var e;
      return (e = l.value[0]) === null || e === void 0 ? void 0 : e.isMinuteDisabled;
    }),
    isEndMinuteDisabledRef: n(() => {
      var e;
      return (e = l.value[1]) === null || e === void 0 ? void 0 : e.isMinuteDisabled;
    }),
    isStartSecondDisabledRef: n(() => {
      var e;
      return (e = l.value[0]) === null || e === void 0 ? void 0 : e.isSecondDisabled;
    }),
    isEndSecondDisabledRef: n(() => {
      var e;
      return (e = l.value[1]) === null || e === void 0 ? void 0 : e.isSecondDisabled;
    })
  }, o = n(() => {
    const {
      type: e,
      isDateDisabled: a
    } = s, {
      value: t
    } = r;
    return t === null || !Array.isArray(t) || !["daterange", "datetimerange"].includes(e) || !a ? !1 : a(t[0], "start", t);
  }), v = n(() => {
    const {
      type: e,
      isDateDisabled: a
    } = s, {
      value: t
    } = r;
    return t === null || !Array.isArray(t) || !["daterange", "datetimerange"].includes(e) || !a ? !1 : a(t[1], "end", t);
  }), c = n(() => {
    const {
      type: e
    } = s, {
      value: a
    } = r;
    if (a === null || !Array.isArray(a) || e !== "datetimerange")
      return !1;
    const t = A(a[0]), u = I(a[0]), b = M(a[0]), {
      isStartHourDisabledRef: m,
      isStartMinuteDisabledRef: y,
      isStartSecondDisabledRef: R
    } = d;
    return (m.value ? m.value(t) : !1) || (y.value ? y.value(u, t) : !1) || (R.value ? R.value(b, u, t) : !1);
  }), f = n(() => {
    const {
      type: e
    } = s, {
      value: a
    } = r;
    if (a === null || !Array.isArray(a) || e !== "datetimerange")
      return !1;
    const t = A(a[1]), u = I(a[1]), b = M(a[1]), {
      isEndHourDisabledRef: m,
      isEndMinuteDisabledRef: y,
      isEndSecondDisabledRef: R
    } = d;
    return (m.value ? m.value(t) : !1) || (y.value ? y.value(u, t) : !1) || (R.value ? R.value(b, u, t) : !1);
  }), D = n(() => o.value || c.value), S = n(() => v.value || f.value), i = n(() => D.value || S.value);
  return Object.assign(Object.assign({}, d), {
    isStartDateInvalidRef: o,
    isEndDateInvalidRef: v,
    isStartTimeInvalidRef: c,
    isEndTimeInvalidRef: f,
    isStartValueInvalidRef: D,
    isEndValueInvalidRef: S,
    isRangeInvalidRef: i
  });
}
export {
  j as dualCalendarValidation,
  V as uniCalendarValidation
};
